"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAfterCloseCallback = void 0;
var _usePrevious = require("../../../hooks/usePrevious/usePrevious");
var _react = require("react");
var useAfterCloseCallback = function useAfterCloseCallback(isOpen, afterClose, closeTimeout) {
  var previousIsOpen = (0, _usePrevious.usePrevious)(isOpen);
  (0, _react.useEffect)(function () {
    var timeout;
    if (afterClose && previousIsOpen && !isOpen) {
      timeout = setTimeout(function () {
        afterClose();
      }, closeTimeout);
    }
    return function () {
      return clearTimeout(timeout);
    };
  }, [previousIsOpen, isOpen, afterClose, closeTimeout]);
};
exports.useAfterCloseCallback = useAfterCloseCallback;